/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'extension.charts.aggregateData': '汇总数据',
  'extension.charts.aggregateDataDescription': '当多行的值相同时，将这些值合并为单个数据点。',
  'extension.charts.category': '类别',
  'extension.charts.customizeTab': '自定义',
  'extension.charts.dataMissing.details': '未在页面上找到此图表的源表。',
  'extension.charts.dataMissing.title': '没有要显示的数据',
  'extension.charts.dataTab': '数据',
  'extension.charts.defaultColumnName': '列 {0}',
  'extension.charts.defaultTitle': '无标题图表',
  'extension.charts.defaultYLabel': '无标题轴',
  'extension.charts.extensionTitle': '图表',
  'extension.charts.height': '绘图区域高度',
  'extension.charts.height.large': '更高',
  'extension.charts.height.medium': '默认',
  'extension.charts.height.small': '更短',
  'extension.charts.horizontal.orientation.label': '水平',
  'extension.charts.insert.tooltip': '插入图表',
  'extension.charts.legend': '图例',
  'extension.charts.legend.auto': '自动',
  'extension.charts.legend.bottom': '底部',
  'extension.charts.legend.left': '左侧',
  'extension.charts.legend.position': '图例位置',
  'extension.charts.legend.right': '右侧',
  'extension.charts.legend.show': '显示图例',
  'extension.charts.legend.top': '顶部',
  'extension.charts.options.label': '图表选项',
  'extension.charts.options.tooltip': '更改图表选项',
  'extension.charts.orientation.label': '方向',
  'extension.charts.seriesNames': '数据系列',
  'extension.charts.showPoints': '显示数据点',
  'extension.charts.smoothLines': '平滑线条',
  'extension.charts.style': '样式',
  'extension.charts.title': '标题',
  'extension.charts.type.bar': '条形图',
  'extension.charts.type.fieldDescription': '图表类型',
  'extension.charts.type.line': '线状图',
  'extension.charts.type.pie': '饼图',
  'extension.charts.userTitle': '标题',
  'extension.charts.vertical.orientation.label': '纵向',
  'extension.charts.xAxis': 'X 轴',
  'extension.charts.xLabel': 'X 轴标签',
  'extension.charts.yLabel': 'Y 轴标签',
};
